import React from "react";
import PropTypes from "prop-types";
import capitalize from "capitalize";
import { UserSolidV6 } from "@shared/v2/Icomoon";
import BaseEvent from "./BaseEvent";

const TimelineQualificationFormEvent = ({ event, event: { timeline_fields: timelineFields } }) => {
  const descriptions = [];

  const orderedDetails = {
    selling_or_buying: "Selling or Buying",
    buy_time_frame: "Buy Time Frame",
    sell_time_frame: "Sell Time Frame",
    time_frame: "Time Frame",
    "mortgage_pre-approval": "Mortgage Pre-Approval",
    "morgage_pre-approval": "Mortgage Pre-Approval", // Support typo until code and data are updated
    scheduled_consult: "Scheduled Consult",
    consultation: "Consultation",
  };

  Object.keys(orderedDetails).forEach((key) => {
    const value = timelineFields[key];
    if (!value) return;

    const titleizedValue = capitalize(value);
    const titleizedKey = orderedDetails[key];

    if (key === "time_frame") {
      const sellingOrBuying = timelineFields.selling_or_buying;

      if (!sellingOrBuying) {
        descriptions.push(`${titleizedKey}: ${titleizedValue}`);
      } else {
        const lowerSellingOrBuying = sellingOrBuying.toLocaleLowerCase();

        if (lowerSellingOrBuying === "buying") {
          descriptions.push(`Buy Time Frame: ${titleizedValue}`);
        } else if (lowerSellingOrBuying === "selling") {
          descriptions.push(`Sell Time Frame: ${titleizedValue}`);
        } else if (lowerSellingOrBuying === "both") {
          descriptions.push(`Buy Time Frame: ${titleizedValue}`);
          descriptions.push(`Sell Time Frame: ${titleizedValue}`);
        } else {
          descriptions.push(`${titleizedKey}: ${titleizedValue}`);
        }
      }
    } else {
      descriptions.push(`${titleizedKey}: ${titleizedValue}`);
    }
  });

  return (
    <BaseEvent
      icon={<UserSolidV6 />}
      title="Submitted Form: Qualification"
      interactedAt={event.interacted_at_absolute}
    >
      {descriptions.length > 0 && <div className="tw-font-semibold">Details:</div>}
      {descriptions.map((description) => (
        <div key={`${event.id}-${description}`}>{description}</div>
      ))}
    </BaseEvent>
  );
};

TimelineQualificationFormEvent.propTypes = {
  event: PropTypes.shape().isRequired,
};

export default TimelineQualificationFormEvent;
